import { render, staticRenderFns } from "./drafts-table.vue?vue&type=template&id=2b359b40&scoped=true&"
import script from "./drafts-table.vue?vue&type=script&lang=js&"
export * from "./drafts-table.vue?vue&type=script&lang=js&"
import style0 from "./drafts-table.vue?vue&type=style&index=0&id=2b359b40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b359b40",
  null
  
)

component.options.__file = "drafts-table.vue"
export default component.exports